// Charge l’API YouTube de manière asynchrone
function loadYouTubeAPI() {
  return new Promise((resolve, reject) => {
    if (window.YT && window.YT.Player) {
      resolve(); // Déjà chargée
    } else {
      window.onYouTubeIframeAPIReady = resolve;
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      tag.onerror = reject;
      document.head.appendChild(tag);
    }
  });
}
console.log("Tic");

// Classe pour gérer la vidéo
class VideoManager {

  constructor(rootEl) {
    this.rootEl = rootEl;
    this.videoElement = rootEl.querySelector('.video');        // wrapper visible qui rogne
    this.videoCover = rootEl.querySelector('.video-cover');

    // .iframe doit être un DIV host (pas une iframe)
    this.host = this.ensureHostIsDiv(rootEl.querySelector('.iframe'));

    this.videoPush = rootEl.querySelector('.video_push');
    this.videoImg = rootEl.querySelector('.video_img');

    this.player = null;
    this.currentVideoId = null;

    // flags / observers
    this._hoverBound = false;
    this._boundPushHandler = null;
    this._boundCoverHandler = null;
    this._rafId = null;
    this._lateFix1 = null;
    this._lateFix2 = null;
    this._sizingScheduled = false;
    this.mutationObs = null;
    this.resizeObs = null;

    if (this.isMobile && this.rootEl.dataset.mobileKey && this.videoImg) {
      this.videoImg.style.display = 'none';
    }

    this.init();
    this.sizeHostToCover();
    this._onWinResize = () => this.requestSize();
    window.addEventListener('resize', this._onWinResize);
  }

  // S’assure que .iframe est un DIV hôte
  ensureHostIsDiv(el) {
    if (!el) {
      const host = document.createElement('div');
      host.className = 'iframe';
      this.rootEl.querySelector('.video')?.appendChild(host);
      return host;
    }
    if (el.tagName === 'DIV') return el;
    if (el.tagName === 'IFRAME') {
      const host = document.createElement('div');
      host.className = el.className || 'iframe';
      el.replaceWith(host);
      return host;
    }
    return el;
  }

  get isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  getVideoData() {
    const useMobile = this.isMobile && this.rootEl.dataset.mobileKey;
    return {
      videoId: useMobile ? this.rootEl.dataset.mobileKey : this.rootEl.dataset.key,
      start: useMobile ? (this.rootEl.dataset.mobilestart || 0) : (this.rootEl.dataset.start || 0),
      end: useMobile ? (this.rootEl.dataset.mobileend || 0) : (this.rootEl.dataset.end || 0),
      reduction: useMobile ? (+this.rootEl.dataset.mobileReduction || 0) : (+this.rootEl.dataset.reduction || 0),
      useMobile
    };
  }

  // ---------- COVER : ratio & sizing ----------

  getVideoAspect() {
    const aspectStr = this.isMobile
      ? (this.rootEl.dataset.mobileAspect || this.rootEl.dataset.aspect || '16:9')
      : (this.rootEl.dataset.aspect || '16:9');
    const [w, h] = (aspectStr || '16:9').split(':').map(Number);
    return (w && h) ? (w / h) : (16 / 9);
  }

  computeCoverSize() {
    const container = this.videoElement;
    if (!container) return { w: 0, h: 0 };

    const aspect = this.getVideoAspect();
    const cw = container.clientWidth || 0;
    const ch = container.clientHeight || 0;
    if (!cw || !ch) return { w: 0, h: 0 };

    const containerAspect = cw / ch;
    if (containerAspect > aspect) {
      return { w: ch * aspect, h: ch }; // caler hauteur
    } else {
      return { w: cw, h: cw / aspect }; // caler largeur
    }
  }

  sizeHostToCover() {
    const host = this.host;
    const container = this.videoElement;
    if (!host || !container) return;
  
    const a = this.getVideoAspect(); // ratio w/h de la vidéo
    const cw = container.clientWidth || 0;
    const ch = container.clientHeight || 0;
    if (!cw || !ch || !a) return;
  
    // --- base "CONTAIN" : tient entièrement dans le conteneur sans crop
    let baseW, baseH;
    if (cw / ch > a) {
      // conteneur plus "large" -> on cale sur la hauteur
      baseW = ch * a;
      baseH = ch;
    } else {
      // conteneur plus "étroit/haut" -> on cale sur la largeur
      baseW = cw;
      baseH = cw / a;
    }
  
    // pose la taille base
    host.style.width = `${baseW}px`;
    host.style.height = `${baseH}px`;
  
    // --- scale pour COUVRIR (cover)
    const coverScale = Math.max(cw / baseW, ch / baseH);
  
    // zoom volontaire (optionnel) via data-reduction (%)
    const reduction = this.isMobile
      ? Number(this.rootEl.dataset.mobileReduction || 0)
      : Number(this.rootEl.dataset.reduction || 0);
    const zoomScale = 1 + (reduction / 100);
  
    // marge de sécu optionnelle (utile avec clip-path: circle(150%...))
    const safety = Number(this.rootEl.dataset.scaleSafety || 1);
  
    const totalScale = coverScale * zoomScale * (safety || 1);
  
    // centrage absolu + scale dynamique
    host.style.position = 'absolute';
    host.style.left = '50%';
    host.style.top = '50%';
    host.style.transformOrigin = '50% 50%';
    host.style.transform = `translate(-50%, -50%) scale(${totalScale})`;
  
    // iframe interne en 100%
    const iframe = host.querySelector('iframe');
    if (iframe) {
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = '0';
      iframe.style.display = 'block';
    }
  }

  // Throttle : regroupe tous les recalculs dans un seul rAF
  requestSize() {
    if (this._sizingScheduled) return;
    this._sizingScheduled = true;
    this._rafId = requestAnimationFrame(() => {
      this._sizingScheduled = false;
      this.sizeHostToCover();
    });
  }

  setupMutationObserver() {
    const host = this.host;
    if (!host || this.mutationObs) return;

    // On observe uniquement les ajouts/suppressions d'enfants (pas les styles)
    this.mutationObs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList') {
          this.requestSize(); // dimensionner une fois que l'iframe est là
        }
      }
    });

    this.mutationObs.observe(host, {
      childList: true,
      subtree: false
    });
  }

  checkIfShort() {
    if (!this.player || typeof this.player.getDuration !== 'function') return;
    const duration = this.player.getDuration();
    const isShort = duration < 60;
    this.rootEl?.classList?.toggle('short-video', isShort);
  }

  initPlayer({ videoId, start, end, useMobile }) {
    if (!videoId || videoId === 'undefined') return;

    const autoplay = (useMobile
      ? this.rootEl.dataset.autoplayMobile
      : this.rootEl.dataset.autoplayDesktop) === "true" ? 1 : 0;

    const sound = (useMobile
      ? this.rootEl.dataset.soundMobile
      : this.rootEl.dataset.soundDesktop) === "true" ? 1 : 0;

    const loop = (useMobile
      ? this.rootEl.dataset.loopMobile
      : this.rootEl.dataset.loopDesktop) === "true" ? 1 : 0;

    const playOnHover = this.rootEl.dataset.playOnHover === "true";

    this.currentVideoId = videoId;

    // Placeholder dans le host : YT va le remplacer par son iframe
    const placeholder = document.createElement('div');
    placeholder.className = 'yt-placeholder';
    this.host.appendChild(placeholder);

    this.player = new YT.Player(placeholder, {
      videoId,
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay,
        controls: 0,
        rel: 0,
        iv_load_policy: 3,
        playsinline: 1,
        enablejsapi: 1,
        wmode: 'transparent',
        showinfo: 0,
        color: 'red',
        modestbranding: 1,
        fs: 1,
        loop,
        start,
        end,
        ...(loop && { playlist: videoId }),
        origin: window.location.origin
      },
      events: {
        onReady: (e) => {
          
          // S’assurer que l’iframe est bien dans le host
          const iframe = this.player.getIframe && this.player.getIframe();

          
          if (iframe && iframe.parentElement !== this.host) {
            this.host.appendChild(iframe);
          }

          if (sound === 0) e.target.mute();
          e.target.setPlaybackQuality('hd1080');

          // Sizing initial + protections légères (pas de raf infini)
          this.requestSize();
          clearTimeout(this._lateFix1); clearTimeout(this._lateFix2);
          this._lateFix1 = setTimeout(() => this.requestSize(), 100);
          this._lateFix2 = setTimeout(() => this.requestSize(), 600);

          this.setupMutationObserver();

          setTimeout(() => this.checkIfShort(), 300);


          if (autoplay === 1) {
            setTimeout(() => {
              if (e.target.getPlayerState() !== YT.PlayerState.PLAYING) {
                console.log("Forçage du démarrage de l'autoplay...");
                e.target.playVideo();
              }
            }, 1000); // 1 seconde de délai
          }
  

          // UI play/pause
          if (autoplay === 1) {
            this.videoElement.classList.remove('active', 'noactive');
          } else if (this.videoPush && !this._boundPushHandler) {
            this._boundPushHandler = () => {
              if (this.player.getPlayerState() === 1) {
                this.player.pauseVideo();
                this.videoElement.classList.remove('noactive');
                this.videoElement.classList.add('active');
              } else {
                if (sound === 1) this.player.unMute();
                this.player.playVideo();
                this.videoElement.classList.remove('active');
                this.videoElement.classList.add('noactive');
              }
            };
            this.videoPush.addEventListener('click', this._boundPushHandler);
          }

          // Bouton cover (optionnel)
          if (this.videoPush && this.videoCover && !this._boundCoverHandler) {
            this._boundCoverHandler = () => {
              if (this.player.getPlayerState() === 1) {
                this.player.pauseVideo();
                this.videoCover.classList.remove('inactif');
              } else {
                this.player.playVideo();
                this.videoCover.classList.add('inactif');
              }
            };
            this.videoPush.addEventListener('click', this._boundCoverHandler);
          }

          // Pause/Play au survol (optionnel)
          if (playOnHover && this.videoElement && !this._hoverBound) {
            this._hoverBound = true;
            this.videoElement.addEventListener('mouseenter', () => {
              if (this.player.getPlayerState() !== YT.PlayerState.PLAYING) {
                this.player.playVideo();
                this.videoElement.classList.remove('active', 'noactive');
              }
            });
            this.videoElement.addEventListener('mouseleave', () => {
              if (this.player.getPlayerState() === YT.PlayerState.PLAYING) {
                this.player.pauseVideo();
                this.videoElement.classList.add('active');
              }
            });
          }
        },

        onStateChange: (e) => {
          // Re-check léger (sans boucle)
          this.requestSize();

          if (e.data === YT.PlayerState.ENDED && loop) {
            this.player.loadVideoById({ videoId });
          }
        }
      }
    });
  }

  destroyPlayer() {
    if (this.mutationObs) { this.mutationObs.disconnect(); this.mutationObs = null; }
    if (this.resizeObs) { this.resizeObs.disconnect(); this.resizeObs = null; }
    if (this._rafId) { cancelAnimationFrame(this._rafId); this._rafId = null; }
    clearTimeout(this._lateFix1); clearTimeout(this._lateFix2);

    if (this.player && typeof this.player.destroy === 'function') {
      this.player.destroy();
      this.player = null;
    }
    // on laisse le host en place; YouTube recréera son iframe si besoin
    const ph = this.host?.querySelector('.yt-placeholder');
    if (ph) ph.remove();
  }

  init() {
    // Observer de resize sur le conteneur (plus précis que window.resize seul)
    if ('ResizeObserver' in window && this.videoElement) {
      this.resizeObs = new ResizeObserver(() => this.requestSize());
      this.resizeObs.observe(this.videoElement);
    }

    const data = this.getVideoData();
    this.initPlayer(data);
  }

  updateVideoIfNeeded() {
    const newData = this.getVideoData();

    if (this.videoImg) {
      this.videoImg.style.display = (this.isMobile && this.rootEl.dataset.mobileKey) ? 'none' : '';
    }

    if (newData.videoId !== this.currentVideoId) {
      this.destroyPlayer();
      this.initPlayer(newData);
    } else {
      this.requestSize();
    }
  }
}

// Lancer la logique une fois l’API YouTube chargée
const videoManagers = [];
const videoBlocks = document.querySelectorAll('.wp-block-plune-blocks-video');

loadYouTubeAPI()
  .then(() => {
    videoBlocks.forEach(el => {
      const manager = new VideoManager(el);
      videoManagers.push(manager);
    });
  })
  .catch(err => {
    console.error("Erreur API YouTube :", err);
  });
